<template>
  <div
    class="param-slider"
    :class="{ 'param-slider--arrows': canShowArrows, 'param-slider--vertical': vertical }"
    v-if="items && items.length"
  >
    <button
      type="button"
      :title="vertical ? 'Вверх' : 'Влево'"
      v-if="canShowArrows"
      class="param-slider__arrow"
      :class="{ 'param-slider__arrow--disabled': swiper && swiper.isBeginning }"
      @click="$emit('prev')"
    >
      <IconComponent v-if="vertical" name="arrow-up-1" />
      <IconComponent v-else name="arrow-left-1" />
    </button>
    <div class="param-slider__items swiper" ref="items">
      <div class="swiper-wrapper">
        <div @click="moveToSelectedSlide" class="swiper-slide" v-for="(item, i) in items" :key="i">
          <slot :item="item"></slot>
        </div>
      </div>
    </div>
    <button
      type="button"
      :title="vertical ? 'Вниз' : 'Вправо'"
      v-if="canShowArrows"
      class="param-slider__arrow"
      :class="{ 'param-slider__arrow--disabled': swiper && swiper.isEnd }"
      @click="$emit('next')"
    >
      <IconComponent v-if="vertical" name="arrow-down-1" />
      <IconComponent v-else name="arrow-right-1" />
    </button>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";

export default {
  name: "ProductParamSlider",
  props: {
    items: Array,
    sliderOptions: Object,
  },
  data() {
    return {
      direction: null,
      slidesPerView: null,
      swiper: null,
    };
  },
  computed: {
    canShowArrows() {
      return this.items.length > (this.slidesPerView || 0);
    },
    vertical() {
      return (this.direction || "horizontal") === "vertical";
    },
  },
  mounted() {
    require(["swiper/swiper-bundle.esm.browser.js"], ({ Swiper }) => {
      this.swiper = new Swiper(this.$refs.items, this.sliderOptions);
      this.swiper.on("breakpoint", (swiper, breakpointParams) => {
        this.updateLocalOptions(breakpointParams);
      });
      this.swiper.emit("breakpoint", this.getCurrentBreakpoint());
    });
  },
  methods: {
    slidePrev() {
      this.swiper.slidePrev();
    },
    slideNext() {
      this.swiper.slideNext();
    },
    moveToSelectedSlide() {
      if (this.swiper) {
        this.swiper.slideTo(this.swiper.clickedIndex);
      }
    },
    getCurrentBreakpoint() {
      if (this.sliderOptions.breakpoints) {
        let returnCandidate = this.sliderOptions;
        Object.keys(this.sliderOptions.breakpoints).forEach((key) => {
          if (window.innerWidth > parseInt(key)) {
            returnCandidate = this.sliderOptions.breakpoints[key];
          }
        });
        return returnCandidate;
      }
      return this.sliderOptions;
    },
    updateLocalOptions(options) {
      this.direction = options.direction;
      this.slidesPerView = options.slidesPerView;
    },
  },
  components: { IconComponent },
};
</script>

<style lang="stylus">
@import "~swiper/swiper-bundle.min.css"
.swiper-slide {
  width auto
  height: auto;
  display inline-flex
  align-items center
  justify-content center
}

.param-slider {
  width: 100%;
  display flex
  justify-content flex-start
  align-items flex-start
  position relative

  &--arrows:not(&--vertical) {
    padding 0 50px
  }

  &--arrows&--vertical {
    padding 50px 0
  }

  &--vertical &__arrow {
    &:first-child {
      absolute left top right
      bottom unset
    }

    &:last-child {
      absolute right left bottom
      top unset
    }
  }

  &__arrow {
    z-index: 1;
    margin auto
    box-sizing: border-box;
    width 40px
    height 40px
    display flex
    align-items center
    justify-content center
    cursor pointer
    background none
    padding 0
    border 1px solid var(--gray)
    border-radius 50%
    transition var(--transition)

    &:not(&--disabled):hover {
      border-color var(--main-color)
    }

    &--disabled {
      cursor: default
    }

    .icon {
      width 16px
      height 16px

      svg path {
        stroke var(--main-color)
      }
    }

    &:first-child {
      absolute left top bottom
    }

    &:last-child {
      absolute right top bottom
    }
  }

  &__items {
    width 100%
    height 100%

    .swiper-slide {
      height auto !important
    }
  }
}
</style>
